
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Mail } from "lucide-react";
import React from "react";

interface EmailInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
}

const EmailInput: React.FC<EmailInputProps> = ({ value, onChange, error }) => (
  <div className="space-y-2">
    <Label htmlFor="email">Email</Label>
    <div className="relative">
      <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-black h-4 w-4" />
      <Input
        id="email"
        type="email"
        value={value}
        onChange={onChange}
        className="pl-10"
        placeholder="Enter your email"
        required
        autoComplete="username"
      />
      {error && (
        <div className="text-sm text-red-500 ml-1 mt-1">{error}</div>
      )}
    </div>
  </div>
);

export default EmailInput;
